import { useQuery, useMutation } from "@tanstack/react-query";
import { http } from "../../../../../../../services/HttpService";
import { HTTP_ENDPOINTS, QUERY_KEYS } from "../../../../../../../consts/api";

export const VERTICALS_USAGE_REPORT_ORDER_BY = {
  appointmentCount: "appointment_count",
  name: "name",
};

export const useVericalsUsageReportQuery = (payload, options = {}) => {
  const res = useQuery(
    [QUERY_KEYS.verticalsUsageReport, payload],
    async () =>
      http.get(HTTP_ENDPOINTS.verticalsUsageReport(), { params: payload }),
    { select: (res) => res.data.data, ...options },
  );
  return res;
};

export const useExportVerticalsUsageReport = () => {
  return useMutation(async (payload) =>
    http.get(HTTP_ENDPOINTS.verticalsUsageReport(), {
      params: { ...payload, export: true },
    }),
  );
};
